import {useEffect, useState} from "react";
import {useArquivo} from "@components/shared/arquivos/hooks/useArquivo.tsx";
import {IArquivoData} from "@components/shared/dto/IArquivoData.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {Button, Grid} from "@mui/material";

interface ArquivoProps {
    value: IArquivoData,
    size?: number | 'thumbnail'
}


export function Imagem(props: ArquivoProps) {
    const {value} = props
    const {addPopUp} = useAlert()
    const {getArquivo} = useArquivo()
    const [url, setUrl] = useState<string | undefined>()

    useEffect(() => {
        if (value.blob != null) {
            const url = URL.createObjectURL(value.blob);
            setUrl(url);
            return;
        }

        getArquivo({id: value.id})
            .then((x) => {
                const url = URL.createObjectURL(x);
                setUrl(url);
            })
    }, [value]);

    const size = props.size == 'thumbnail' ? 33 : props.size

    return (url &&
        <img alt={`${value.guid}.${value.extensao}`}
             style={{cursor: 'pointer'}}
             onClick={() => {
                 addPopUp({
                     title: 'Visualização de imagem',
                     content: <Grid container size={12} justifyContent={'center'} alignItems={'center'}>
                         <Grid size={12}>
                             <Button onClick={() => {
                                 const link = document.createElement('a');
                                 link.href = url;
                                 link.download = `${value.guid}.${value.extensao}`;
                                 link.click();
                             }}>Download</Button>
                         </Grid>
                         <Grid size={12} container alignItems={'center'} justifyContent={'center'} maxHeight={'50vh'}>
                             <img alt={`${value.guid}.${value.extensao}`}
                                  style={{maxHeight: 'inherit', maxWidth: 'inherit'}}
                                  src={url}/>
                         </Grid>

                     </Grid>,
                 })
             }} height={size} src={url}/>)
}
